<template lang="pug">
    .layout(style="position: relative;")
        meta(charset="utf-8")

        // 變更密碼和 OTP Token
        Modal(v-model="isModalShow" :title="$t('userInfo.accountSafetyAlert')" :closable="false" :mask-closable="false")
            p(v-if="$store.state.userData.isPasswordExpired && $store.state.userData.isOtpExpired") {{$t('userInfo.passwordAndOtpTokenExpired')}}
            p(v-if="$store.state.userData.isPasswordExpired && !$store.state.userData.isOtpExpired") {{$t('userInfo.passwordExpired')}}
            p(v-if="!$store.state.userData.isPasswordExpired && $store.state.userData.isOtpExpired") {{$t('userInfo.otpTokenExpired')}}
            div(slot="footer")
                Button(@click="redirectToUserInfo()") {{$t('userInfo.go')}}

        Layout.main(:style="{ minHeight: '100vh' }")
            Header(style="display: flex; flex-direction: row; position: fixed; width: 100%;z-index: 999")
                .logoDiv(@click="gotoRoute($store.getters.landingPagePath)")
                    img(src="" v-real-img="headerLogo")
                .middleDiv
                    template(v-if="menuDirection == 'horizontal' && ($store.state.queryGroupName !== 'all' || $store.getters.isAdmin)")
                        // 橫列普通選單
                        Menu.horizontalMenu(ref="horizontal_menu" mode="horizontal" theme="dark" :active-name="activeMenuName" @on-select="getSelectedMenu" v-model="isCollapsed" :style="{background: 'transparent',display:'flex',justifyContent: 'center',alignItems: 'center',height: '100%'}")
                            template
                                MenuItem.menuItem(:name="$store.getters.landingPagePath" v-if="$store.getters.isAdmin||$store.getters.getNormalUserConfig.hasHomePage")
                                    span(v-text="$t('routesMenu.Home')")
                                template(v-for="(menuItem, mindex) in menuItems")
                                    MenuItem.menuItem(:name="menuItem.showName")
                                        span(v-text="$t('routesMenu.' + menuItem.showName)")
                    template(v-else)
                        //- .carousel
                            Carousel(v-if="!isCollapsed" loop :autoplay="announcement.length > 1" :dots="'none'" :arrow="'never'" :easing="'ease'" :autoplay-speed="10000" :key="$store.state.userPref.lang")
                                CarouselItem(v-for="(announce, index) in announcement" :key="index")
                                    pre {{announce}}
                        ResourceLauncher(v-if="!isCollapsed")
                        ResourceLauncherMob(v-else)

                .headerItemsDiv
                    .header-right-content
                        MainNav(v-if="!isCollapsed" @changeLocale="reloadRouterView()")
                        MainNavMob(v-else @changeLocale="reloadRouterView()")
            Layout
                Sider(style="min-width: 230px;position: fixed;min-height: 100vh;max-height: 100vh;z-index: 999;margin-top: 64px;padding-bottom: 64px;overflow-y:scroll" ref="mainSider" hide-trigger breakpoint="lg" collapsible :collapsed-width="60" v-model="isCollapsed" v-if="menuDirection != 'horizontal'" v-show="(!$store.getters.isAdmin && $store.state.queryGroupName !== 'all' || $store.getters.isAdmin) && menuDirection != 'horizontal' || isCollapsed" transfer)
                    // 普通菜單
                    template(v-if="!isCollapsed")
                        Menu(ref="side_menu" :active-name="activeMenuName" :open-names="openMenuName" theme="dark" width="auto" :class="menuitemClasses")
                            MenuItem(:name="$store.getters.landingPagePath" v-if="$store.getters.isAdmin||$store.getters.getNormalUserConfig.hasHomePage" :to="$store.getters.landingPagePath")
                                Icon(type="ios-home")
                                span(v-text="$t('routesMenu.Home')")
                            template(v-for="(menuItem, mindex) in menuItems")
                                Submenu(:name="menuItem.showName")
                                    template(slot="title")
                                        Icon(:type="menuItem.icon")
                                        span(
                                            v-text="$t('routesMenu.' + menuItem.showName)"
                                        )
                                    template(v-for="subItem in menuItem.subItems")
                                        MenuItem(:name="subItem.showName" :to="subItem.path") {{ $t('routesMenu.' + subItem.showName) }}
                    // 摺疊菜單
                    template(v-else)
                        Dropdown(placement="right-start")
                            a(@click="gotoRoute($store.getters.landingPagePath)")
                                Icon(type="ios-home")
                        template(v-for="(menuItem, mindex) in menuItems")
                            Dropdown(trigger="click" @on-click="gotoRoute" :name="menuItem.path" placement="right-start" transfer)
                                a
                                    Icon(:type="menuItem.icon")
                                DropdownMenu(slot="list")
                                    template(v-for="subItem in menuItem.subItems")
                                        DropdownItem(:name="subItem.path") {{ $t('routesMenu.' + subItem.showName) }}
                Layout(:style="layoutStyle")
                    Content.content-wrapper
                        Menu.horizontalSubmenu(ref="horizontal_menu" mode="horizontal" theme="primary" v-if="routeName !== 'home' && routeName !== 'dashboard' && routeName !== 'userinfo' && menuDirection == 'horizontal' && menuItems[menuIndex] && ($store.state.queryGroupName !== 'all' || $store.getters.isAdmin) && !isCollapsed && menuItems[menuIndex].subItems.length > 1" :style="{background: 'transparent',height:'64px',display:'flex',justifyContent: 'flex-start',alignItems: 'center'}" :active-name="activeSubMenuName" :class="menuitemClasses")
                            template(v-for="subItem in menuItems[menuIndex].subItems")
                                MenuItem.menuItem(:name="subItem.showName" :to="subItem.path") {{$t('routesMenu.' + subItem.showName)}}
                        Alert(v-if="isAlertShow" :type="alertType" show-icon)
                            p(v-if="hasBillingCard") {{ $t("accountInfo.remind.titleSetCardText") }}
                            p(v-if="leftDays>0 && !hasBillingCard") {{ $t('accountInfo.error.noSubscriptionText') }}：{{leftDays}}{{ $t('accountInfo.trialPeriodUnitText') }}
                            p(v-if="isUnpaid&&hasBillingSubscription&&leftDays<0") {{ $t('accountInfo.error.paymentFailText') }}
                            Row(type="flex" justify="space-between" slot="desc")
                                Col
                                    p(v-if="hasBillingCard") {{ $t('accountInfo.error.noCardText') }}
                                    p(v-else) {{ $t('accountInfo.error.descriptionOneText') }} {{endDate}},{{ $t('accountInfo.error.descriptionTwoText') }}
                                Col(style="width: 100%; text-align: right;")
                                    Button(type="default" to="/account-info/payment") {{ $t('accountInfo.error.setBtnText') }}
                        //- Alert(v-if="$store.state.queryGroupName!='all'")
                        //-     Row(type="flex" justify="space-between" slot="desc")
                        //-         p {{$t('main.group')}} : {{$store.state.queryGroupName}}
                        router-view(:key="$route.fullPath" v-if="isRouterAlive")

                        notifications(group="success" :position="notificationPosition" :duration="5000" :width="500" animation-name="v-fade-bottom" classes="successNotice")
                            template(slot="body" slot-scope="props")
                                .successNotice
                                    .successNotice-icon
                                        Icon(type="md-checkmark-circle-outline" size="32")
                                    .successNotice-content
                                        .successNotice-title {{props.item.title}}
                                        .successNotice-text(v-html="props.item.text")
                                    .successNotice-close(@click="props.close")
                                        Icon(type="md-close"  size="16")
                        notifications(group="error" :position="notificationPosition" :duration="5000" :width="500" animation-name="v-fade-bottom" classes="errorNotice")
                            template(slot="body" slot-scope="props")
                                .errorNotice
                                    .errorNotice-icon
                                        Icon(type="ios-close-circle-outline" size="32")
                                    .errorNotice-content
                                        .errorNotice-title {{props.item.title}}
                                        .errorNotice-text(v-html="props.item.text")
                                    .errorNotice-close(@click="props.close")
                                        Icon(type="md-close"  size="16")


</template>
<script>
import { getMenuItems } from "@/api/menu";
import { getJwtToken } from "@/api/user";
import bus from "@/libs/bus.js";
import MainNav from "@/components/Main/MainNav";
import MainNavMob from "@/components/Main/MainNavMob";
import ResourceLauncher from "@/components/ResourceLauncher";
import ResourceLauncherMob from "@/components/ResourceLauncherMob";
import PaymentPage from "./AccountInfo/payment";

import Vue from "vue";
import store from "@/store";
import VueSocketIO from "vue-socket.io";

import { getSystemFrontendConfig, getPlatformPlan } from "@/api/system";
import { getGroupNames, getGroupResourceLimits } from "@/api/group";
import { getUserData } from "@/api/user";
import { getEsData } from "@/api/esdata";
import { _login, resetPassword, resendOtpMail } from "@/api/user.js";

import moment from "moment";

Vue.use(
    new VueSocketIO({
        // debug: true,
        // connection: process.env.BACKEND_URL,
        connection: `${location.protocol}//${location.host}`,
        vuex: {
            store,
            actionPrefix: "SOCKET_",
            mutationPrefix: "SOCKET_",
        },
    })
);

export default {
    name: "Main",
    components: {
        MainNav,
        MainNavMob,
        ResourceLauncher,
        ResourceLauncherMob,
        PaymentPage,
    },
    data() {
        return {
            menuItems: [],
            isCollapsed: false,
            isRouterAlive: true,
            openMenuName: [],
            activeMenuName: "",
            activeSubMenuName: "",
            currentMenuIndex: -1,
            userBillingInfoQuery: {},
            createdDate: new Date(),
            endDate: "2022-09-01",
            hasBillingSubscription: false,
            isUnpaid: false,
            hasBillingCard: false,
            alertType: "error",
            isModalShow: false,
        };
    },
    methods: {
        filterIsShownMenuItems() {
            return this.menuItems.filter((item) => {
                if (item.subItems) {
                    item.subItems = item.subItems.filter((i) => i.isShown == true);
                }
                return item.isShown == true;
            });
        },
        gotoRoute(path) {
            if (path != "") {
                let routeTo = { path };
                let { groupName } = this.$route.query;
                if (groupName) routeTo.query = { groupName };
                this.$router.push(routeTo);
            }
        },
        reloadRouterView() {
            getGroupNames().then((groupNames) => {
                this.$store.commit("SET_ALL_GROUPNAMES", groupNames);
            });
            this.isRouterAlive = false;
            this.$nextTick(() => {
                this.isRouterAlive = true;
            });
        },
        // 用於初次加載, 和跳轉至子菜單時
        updateMenuOpenedNames() {
            this.openMenuName = [];
            this.activeMenuName = "";

            let currentActiveParent = this.menuItems.find((item) => {
                return item.subItems.find((subItem) => {
                    return subItem.path == this.activeMenuPath;
                });
            });

            if (this.menuDirection == "horizontal") {
                this.activeMenuName = currentActiveParent.showName;
                let currentActiveMenu = currentActiveParent.subItems.find((item) => {
                    return item.path == this.activeMenuPath;
                });
                this.activeSubMenuName = currentActiveMenu.showName;
                this.$nextTick(() => {
                    this.$refs.horizontal_menu.updateActiveName();
                });
            } else {
                this.menuItems.forEach((item) => {
                    item.subItems.forEach((subItem) => {
                        if (subItem.path == this.activeMenuPath) {
                            // this.$refs.side_menu.openedNames = [];
                            this.$refs.side_menu.openedNames.push(item.showName);
                            this.openMenuName = this.$refs.side_menu.openedNames;
                        }
                    });
                });

                // this.openMenuName = this.$refs.side_menu.openedNames;
                // this.openMenuName.push(currentActiveParent.showName);
                if (currentActiveParent) {
                    let currentActiveMenu = currentActiveParent.subItems.find((item) => {
                        return item.path == this.activeMenuPath;
                    });
                    this.activeMenuName = currentActiveMenu.showName;
                }

                this.$nextTick(() => {
                    this.$refs.side_menu.updateOpened();
                    this.$refs.side_menu.updateActiveName();
                });
            }
        },
        // 點擊horizontal父欄位, 進入第一個子頁籤頁面
        getSelectedMenu(name) {
            this.activeMenuName = name;
            if (name.includes("/") == true || name == "/home") {
                this.gotoRoute(name);
            } else {
                let subPath = "";
                for (let i = 0; i < this.menuItems.length; i++) {
                    if (name == this.menuItems[i].showName) {
                        subPath = this.menuItems[i].subItems[0].path;
                    }
                }
                this.gotoRoute(subPath);
            }
        },
        async getUserPaymentInfo() {
            if (this.$store.state.queryGroupName == "all") return "";
            await getEsData(this.userBillingInfoQuery)
                .then((result) => {
                    let hasBillingInfo = result.data.mapData[0].billing ? true : false;

                    if (hasBillingInfo) {
                        this.$store.commit("SET_USER_PAYMENT_INFO", result.data.mapData[0].billing);

                        let billingInfo = result.data.mapData[0].billing;
                        // console.log(billingInfo.paymentStatus, "billingInfo");
                        if (billingInfo.subscription) {
                            this.hasBillingSubscription = true;
                        } else {
                            this.hasBillingSubscription = false;
                        }

                        if (!billingInfo.cardId) {
                            this.hasBillingCard = true;
                        } else {
                            this.hasBillingCard = false;
                        }

                        // 有訂閱,付款失敗
                        if (billingInfo.subscription && !billingInfo.paymentStatus) {
                            this.hasBillingCard = false;
                        }

                        this.$store.commit("SET_USER_HAS_SUBSCRIPTION", this.hasBillingSubscription);

                        if (billingInfo.paymentStatus !== undefined) {
                            // console.log("有付過款");
                            this.isUnpaid = !billingInfo.paymentStatus;
                        } else {
                            // console.log("沒付過款");

                            this.isUnpaid = false;
                        }
                        this.$store.commit("SET_USER_PAYMENT_STATUS", !this.isUnpaid);
                    } else {
                        this.hasBillingSubscription = false;
                        this.$store.commit("SET_USER_PAYMENT_INFO", {});
                    }
                    this.createdDate = result.data.mapData[0].createdDate;
                    this.$store.commit("SET_USER_CREATE_DATE", this.createdDate);
                    this.endDate = moment().add(1, "months").format("YYYY-MM-01");
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        redirectToUserInfo() {
            this.isModalShow = false;
            this.$router.push({ path: "/account-info/user" });
        },
    },
    mounted() {
        if (this.$store.state.queryGroupName !== "all" || this.$store.getters.isAdmin) {
            let currentPath = this.$route.path;

            //  獲取菜單
            getMenuItems({ menu: "mainsidebar", groupName: this.$store.state.queryGroupName })
                .then((res) => {
                    this.menuItems = res.data;
                    this.menuItems = this.filterIsShownMenuItems();
                    this.$store.commit("SET_MENU_ITEMS", this.filterIsShownMenuItems());
                    this.$nextTick(() => {
                        this.updateMenuOpenedNames();
                    });
                })
                .catch((err) => {
                    console.log(err);
                });

            // 獲取每個群的限制
            getGroupResourceLimits({ groupName: this.$store.state.queryGroupName })
                .then((groupResourceLimits) => {
                    this.$store.commit("SET_GROUP_RESOURCE_LIMITS", {
                        groupName: this.$store.state.queryGroupName,
                        groupResourceLimits,
                    });
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    },
    created() {
        bus.$on("reloadRouterView", () => {
            this.updateMenuOpenedNames();
            this.reloadRouterView();
        });

        bus.$on("SET_QUERY_GROUPNAME", (groupName) => {
            this.$router.push({ query: { groupName } });
            this.$store.commit("SET_QUERY_GROUPNAME", groupName);

            this.reloadRouterView();

            // 獲取每個群的限制
            getGroupResourceLimits({ groupName: this.$store.state.queryGroupName })
                .then((groupResourceLimits) => {
                    this.$store.commit("SET_GROUP_RESOURCE_LIMITS", {
                        groupName: this.$store.state.queryGroupName,
                        groupResourceLimits,
                    });
                })
                .catch((err) => {
                    console.log(err);
                });
        });

        // 獲取使用者資料
        getUserData()
            .then((res) => {
                this.$store.commit("SET_USER_DATA", res.data);
                // 先判斷是否forceUpdatePassword&forceUpdateOtpToken 是否關閉
                if (
                    !this.$store.state.platformPlan.multiTenancyConfigs.forceUpdatePassword &&
                    !this.$store.state.platformPlan.multiTenancyConfigs.forceUpdateOtpToken
                ) {
                    return;
                }

                if (this.$store.state.userData.isPasswordExpired || this.$store.state.userData.isOtpExpired) {
                    this.isModalShow = true;
                }
            })
            .catch((err) => {
                console.log(err);
                this.$store.commit("SET_USER_DATA", {});
                this.$router.push({ name: "login" });
            });

        // 獲取平台資訊
        getSystemFrontendConfig()
            .then((res) => {
                this.$store.commit("SET_FRONTEND_CONFIGS", res.data);
            })
            .catch((err) => {
                console.log(err);
            });

        // 獲取平台限制
        getPlatformPlan({ groupName: this.$store.state.queryGroupName })
            .then((res) => {
                this.$store.commit("SET_PLATFORM_PLAN", res.data);
            })
            .catch((err) => {
                console.log(err);
            });

        // 獲取全部群組
        // if (this.$store.getters.isAdmin) {

        // }
        getGroupNames().then((groupNames) => {
            this.$store.commit("SET_ALL_GROUPNAMES", groupNames);
        });
        this.getUserPaymentInfo();
    },
    beforeDestroy() {
        this.$bus.$off("reloadRouterView");
        this.$bus.$off("SET_QUERY_GROUPNAME");
        window.removeEventListener("resize", this.onResize);
    },
    computed: {
        isAlertShow() {
            var alertShow = false;
            if (this.hasBillingCard && this.hasBillingPermission && this.$store.state.queryGroupName != "all") {
                // console.log("沒綁卡，有權限");
                this.alertType = "warning";
                alertShow = true;
            } else if (this.leftDays > 3 && this.hasBillingPermission) {
                // console.log("試用期內，有權限");
                alertShow = false;
            } else if (
                0 < this.leftDays &&
                this.leftDays <= 3 &&
                this.hasBillingPermission &&
                !this.hasBillingSubscription
            ) {
                // console.log("試用期剩三天，有權限，沒訂閱");
                this.alertType = "warning";
                alertShow = true;
            } else if (this.leftDays <= 0 && this.hasBillingPermission && !this.hasBillingSubscription) {
                // console.log("已過試用期，有權限，沒訂閱");
                this.alertType = "error";
                alertShow = true;
            } else if (this.isUnpaid && this.hasBillingPermission && this.hasBillingSubscription) {
                // console.log("沒付款，有權限，有訂閱");
                this.alertType = "error";
                alertShow = true;
            }
            return alertShow;
        },
        leftDays() {
            var currentDate = moment().format("YYYY-MM-DD");
            var expiryDate = moment(this.createdDate).add(30, "days").format("YYYY-MM-DD");
            return moment(expiryDate).diff(currentDate, "days");
        },
        // isShowLeftDaysAlert() {
        //     return this.leftDays <= 3;
        // },
        hasBillingPermission() {
            return (
                this.$can("read", "billingPermission", "") &&
                // !this.$store.getters.isAdmin &&
                this.$store.state.platformPlan.multiTenancyConfigs.isAllowPaymentShow
            );
        },
        layoutStyle() {
            if (
                (!this.$store.getters.isAdmin && this.$store.state.queryGroupName == "all") ||
                (this.$store.getters.isAdmin && this.menuDirection == "horizontal")
            ) {
                return { marginLeft: "0px" };
            }
            if (
                (!this.$store.getters.isAdmin &&
                    this.$store.state.queryGroupName !== "all" &&
                    this.menuDirection == "vertical" &&
                    this.isCollapsed) ||
                (this.$store.getters.isAdmin && this.menuDirection == "vertical" && this.isCollapsed)
            ) {
                return { marginLeft: "60px" };
            }
            if (
                (!this.$store.getters.isAdmin &&
                    this.$store.state.queryGroupName !== "all" &&
                    this.menuDirection == "vertical" &&
                    !this.isCollapsed) ||
                (this.$store.getters.isAdmin && this.menuDirection == "vertical" && !this.isCollapsed)
            ) {
                return { marginLeft: "230px" };
            }
        },
        notificationPosition() {
            return this.$store.getters.getNotificationPosition;
        },
        activeMenuPath() {
            // 只看第一層目錄
            return `/${this.$route.path.split("/")[1]}`;
        },
        menuitemClasses() {
            return ["menu-item", this.isCollapsed ? "collapsed-menu" : ""];
        },
        announcement() {
            let userLang = this.$store.state.userPref.lang;
            let announce =
                this.$store.state.frontendConfigs && this.$store.state.frontendConfigs.announcement
                    ? this.$store.state.frontendConfigs.announcement[userLang]
                    : [];
            return announce;
        },
        menuIndex() {
            let menuIndex = -1;
            for (let i = 0; i < this.menuItems.length; i++) {
                if (this.activeMenuName == this.menuItems[i].showName) {
                    menuIndex = i;
                    this.currentMenuIndex = i;
                }
            }
            return menuIndex;
        },
        menuDirection() {
            return this.$store.getters.getMenuDirection;
        },
        routeName() {
            return this.$route.name;
        },
        headerLogo() {
            return this.$store.getters.getInnerPageImg.headerLogoImgName;
        },
    },
    watch: {
        activeMenuPath: {
            deep: true,
            immediate: true,
            handler: function (val) {
                // this.updateMenuOpenedNames();
                if (this.menuDirection == "vertical") {
                    this.menuItems.forEach((item) => {
                        item.subItems.forEach((subItem) => {
                            if (subItem.path == val) {
                                this.$refs.side_menu.openedNames.push(item.showName);
                                this.openMenuName = this.$refs.side_menu.openedNames;
                            }
                        });
                    });
                }
            },
        },

        // 子項目激活展開對應父級菜單
        $route: function (newVal, oldVal) {
            this.updateMenuOpenedNames();
        },
        "$store.state.userHadCard": {
            deep: true,
            handler: function (newVal) {
                this.hasBillingCard = newVal;
                if (newVal) {
                    this.alertType = "warning";
                } else {
                    this.alertType = "error";
                }
            },
        },
        "$store.state.userHasSubscription": {
            deep: true,
            immediate: true,
            handler: function (newVal) {
                if (newVal == true) {
                    this.hasBillingSubscription = true;
                }
            },
        },
        "$store.state.userPaymentStatus": {
            deep: true,
            immediate: true,
            handler: function (newVal) {
                this.isUnpaid = !newVal;
            },
        },
        "$store.state.queryGroupName": {
            deep: true,
            immediate: true,
            handler: function (newVal, oldVal) {
                this.reloadRouterView();
                if (newVal !== "all") {
                    this.userBillingInfoQuery = {
                        isFuzzySearch: false,
                        esIndex: "rcm-edgegroup",
                        from: 0,
                        sort: [{ modifiedDate: { order: "desc" } }],
                        filters: [
                            {
                                key: "groupName",
                                type: "string",
                                value: newVal,
                            },
                        ],
                        _source: ["billing", "createdDate"],
                    };
                    this.hasBillingSubscription = false;

                    this.getUserPaymentInfo();

                    getMenuItems({ menu: "mainsidebar", groupName: newVal })
                        .then((res) => {
                            this.menuItems = res.data;
                            this.menuItems = this.filterIsShownMenuItems();
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }
            },
        },
    },
    sockets: {
        socketNotice: function (data) {
            if (data.success !== undefined) {
                if (data.success == true) {
                    this.$Notice.success({
                        title: this.$t("global.success"),
                        desc: data.message,
                    });
                    bus.$emit("reloadTable");
                } else {
                    this.$Notice.error({
                        title: this.$t("global.error"),
                        desc: data.message,
                    });
                }
            }
            if (data.warning) {
                this.$Notice.warning({
                    title: this.$t("global.warning"),
                    desc: data.message,
                });
            }
            if (data.cmBusEvents) {
                data.cmBusEvents.forEach((e) => {
                    bus.$emit(e.componentName, e.busEvent);
                });
            }
        },
    },
};
</script>
<style lang="less">
.logoDiv {
    display: flex;
    align-items: center;
    cursor: pointer;
    img {
        max-width: 180px;
        margin: 0 10px;
        max-height: 60px;
        min-width: 180px;
    }
}
.middleDiv {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
}
.headerItemsDiv {
    display: flex;
}

.main .content-wrapper {
    padding: 90px 16px 16px;
}

.header-right-content {
    float: right;
    height: auto;
    padding-right: 20px;
    line-height: 64px;
}

.ivu-layout-header {
    padding: 0px;
    height: 64px;
}
.headerLogoBlock {
    width: 175px;
    height: 40px;
    background-color: grey;
    margin: 0 15px;
}

/* 折疊後寬度 */
.ivu-layout-sider.ivu-layout-sider-zero-width.ivu-layout-sider-collapsed {
    width: 60px !important;
    min-width: 60px !important;
    max-width: 60px !important;
    flex: 0 0 60px !important;
}

.ivu-select-dropdown {
    width: auto;
}

.header-right-content .ivu-dropdown {
    padding: 0 10px;
}

.ivu-layout-sider-children > .ivu-dropdown {
    display: inline-block;
    text-align: center;
    padding: 6px 15px;
    font-size: 25px;
    width: 100%;
}

// .ivu-dropdown-rel > a > i.ivu-icon {
//     color: rgba(255, 255, 255, 0.7);
// }

a:hover {
    color: #fff;
}

.carousel {
    color: white;
    width: 500px;
}

/*  rcm.theme.less 更改激活時顏色 */
/* .horizontalSubmenu > .ivu-menu-item-active, .horizontalSubmenu > .ivu-menu-item-selected {
    background: aqua;
} */

.horizontalSubmenu {
    z-index: 1;
}

.horizontalMenu > .menuItem {
    line-height: 1.6;
    padding: 15px;
    font-size: 14px;
    background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/view/general/Main.vue